BOLD.helpers = BOLD.helpers || {};
BOLD.helpers.debounce = function debounce(debounced_function, wait, identifier){
  var identifier = 'dbounce' + identifier + Math.random();
  return function(){
    var context = this, args = arguments
    BOLD.debounceIDs = BOLD.debounceIDs || {};
    clearTimeout(BOLD.debounceIDs[identifier+(this.id || this.name)]);
    BOLD.debounceIDs[identifier+(this.id || this.name)] = setTimeout(function(){ debounced_function.apply(context, args); delete BOLD.debounceIDs[identifier+this.id]; }, wait)
  }
};


BOLD.BMS = BOLD.BMS || {}
BOLD.BMS.minOptionsPriceHandler = function(minExtras){
  this.minExtras = parseInt(minExtras);
  this.setupEventListeners();
}

BOLD.BMS.minOptionsPriceHandler.prototype = {
  setupEventListeners:function(){
    if(!BOLD.options) {
      return;
    }
    BOLD.common.eventEmitter.on('BOLD_COMMON_variant_changed', this.applyMinExtras, this);
    BOLD.common.eventEmitter.on('BOLD_COMMON_cart_fixed', this.applyMinExtras, this);
    BOLD.options.app.on('total_changed', this.applyMinExtras, this)
    BOLD.options.app.on('price_updated', this.applyMinExtras, this)
    BOLD.options.app.on('options_loaded', this.applyMinExtras, this)

  },
  sumSelectedOptionsAndMinRequiredOptionPrices:function(){
    var total = 0;
    for(var os=0; os<this.optionProduct.optionSets.length; os++){
      var optionSet = this.optionProduct.optionSets[os];
      for(var o=0; o<optionSet.options.length; o++){
        var option = optionSet.options[o];
        if(!option.isPricedOption){
          continue;
        }

        total += this.getSelectedOrMinPrice(option);
      }
    }
    return total;
  },
  getSelectedOrMinPrice:function(option){
    var selectedValues = option.getSelectedValues();
    if(!selectedValues.length && option.isRequired){
      // Reducer to get the lowest-priced required option
      return option.optionValues.reduce(function(acc, val){ return (acc == null ? val.price : Math.min(acc, val.price) ) }, null);
    } else {
      // Otherwise, add up the prices of the seleceted values
      return selectedValues.reduce(function(acc, val){ acc += val.price; return acc; }, 0)
    }
  },
  applyMinExtras:BOLD.helpers.debounce(function(evt){
   var optionProduct = this.optionProduct = this.optionProduct || (evt.data ? evt.data.option_product : null);
    if(!optionProduct && BOLD.options.app.optionProducts.length === 1){
      optionProduct = this.optionProduct = BOLD.options.app.optionProducts[0];
    }
   if(!optionProduct){
     console.log('No optionproduct yet')
     return
   }

   var totalExtras = this.sumSelectedOptionsAndMinRequiredOptionPrices();
   var priceHandler = optionProduct.priceHandler;

   if(priceHandler.total < totalExtras){
     var elementsToUpdate = priceHandler.DOMElementsForTotal || document.querySelectorAll('.' + BOLD.options.settings.frontend.option_price_display_class);
     if(!elementsToUpdate){
       console.log('No elements to update yet')
       return;
     }
     var grandTotal = totalExtras + (priceHandler.productPrice || 0);
     for(var e=0; e<elementsToUpdate.length; e++){
       var element = elementsToUpdate[e];
       element.innerHTML = BOLD.common.Shopify.formatMoney(grandTotal, BOLD.common.Shopify.shop.money_format)
     }

   }
 },50)
}
